module.exports = __webpack_public_path__ + "static/media/bg1.9fa5c0e4.png";